<template>
    <div>
        <ul class="tbs d-flex" v-if="$route.name != 'custom-view'">
            <li :class="(order == 'open')?'active':' '">
                <a @click.prevent="tab('open')" href="#">{{$t('open_positions')}}</a>
            </li>
            <!-- <li :class="(order == 'pending')?'active':' '">
                <a @click.prevent="tab('pending')" href="#">{{$t('pending_orders')}}</a>
            </li> -->
            <li :class="(order == 'history')?'active':' '">
                <a @click.prevent="tab('history')" href="#">{{$t('closed_positions')}}</a>
            </li>
            <!-- <li :class="(order == 'transition-history')?'active':''">
                <a @click.prevent="tab('transition-history')" href="#">{{$t('finance')}}Transactions History</a>
            </li> -->
        </ul>
    </div>
</template>
<script>
export default {
    name: 'order-tabing',
    data() {
        return {}
    },
    props:{
        order:{
            default: ''
        }
    },
    methods:{
        tab(valve){
            this.$parent.$parent.order = valve
            this.$parent.$parent.page = '1'
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/copy-order/tab-section.vue